import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

export function SidebarWrapper({ isOpenSidebar, toggleSideBar, children }) {
    return (
        <Transition.Root show={isOpenSidebar} as={Fragment}>
            <Dialog
                as="div"
                static
                className="fixed inset-0 z-50 overflow-hidden"
                open={isOpenSidebar}
                onClose={toggleSideBar}>
                <div className="absolute inset-0 overflow-hidden">
                    <div className="fixed inset-y-0 right-0 flex w-80">
                        <Transition.Child
                            as={Fragment}
                            enter="transform transition ease-in-out duration-500 sm:duration-700"
                            enterFrom="translate-x-full backdrop-blur-sm"
                            enterTo="translate-x-0 backdrop-blur-sm"
                            leave="backdrop-blur-sm transform transition ease-in-out duration-500"
                            leaveFrom="translate-x-0"
                            leaveTo="translate-x-full">
                            <Dialog.Panel className="w-full">
                                <div className="flex h-full rounded-br-lg rounded-tr-lg border border-white bg-white/80 shadow-icoXL backdrop-blur-sm firefox:bg-gradient-to-tr firefox:from-icoGrayFirefox-300 firefox:to-icoWhiteFirefox dark:border-icoDarkMode-deepBlack dark:bg-icoDarkMode-deepBlack/80 dark:firefox:from-icoDarkMode-deepBlack dark:firefox:to-icoDarkMode-anthracite">
                                    {children}
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
